import { Invitations } from "pages/Invitations/Invitations";

export default Invitations;
